<template>
<!-- <div class="sidebar-form"></div> -->
</template>
<script>
export default {
  name: 'sidebar-form'
}
</script>



// WEBPACK FOOTER //
// SidebarForm.vue?622be8d7